<template>
    <Dialog v-model:visible="modal" modal header="Chamado" :style="{ width: '75vw' }">
        <Fieldset class="mb-5">
            <template #legend>
                <div class="flex align-items-center text-primary">
                    <span class="pi pi-phone"></span>
                </div>
            </template>

            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-12">
                    <label for="emailSolicitante">E-mail do Solicitante</label>
                    <InputText id="emailSolicitante" optionLabel="nome" class="font-bold" :value="chamado.createdBy" disabled></InputText>
                </div>

                <div class="field col-12 md:col-6">
                    <label for="tipoChamado">Tipo do Chamado</label>
                    <InputText id="tipoChamado" optionLabel="nome" class="font-bold" :value="chamado.tipoChamado" disabled></InputText>
                </div>

                <div class="field col-12 md:col-6">
                    <label for="dataSolicitacao">Data da Solicitação</label>
                    <InputText id="dataSolicitacao" optionLabel="nome" class="font-bold" :value="chamado.dataCriacao" disabled> </InputText>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="emailSolicitante">Atendente</label>
                    <InputText id="emailSolicitante" optionLabel="nome" class="font-bold" :value="chamado.nomeResponsavel" disabled></InputText>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="dataAtendimento">Data do Atendimento</label>
                    <InputText
                        id="dataAtendimento"
                        optionLabel="nome"
                        class="font-bold"
                        :value="$dateFormat(chamado.dataAtendimento, 'DD/MM/YYYY HH:mm:ss')"
                        disabled
                    >
                    </InputText>
                </div>

                <div class="field col-12 md:col-3">
                    <p for="status">Status</p>
                    <TagStatusChamado :status="chamado.statusChamado" />
                </div>

                <div class="field col-12 md:col-4" v-if="chamado.statusChamado !== 'EM_ANALISE'">
                    <label for="nomeResponsavel">Nome responsável</label>
                    <InputText id="nomeResponsavel" class="font-bold" :value="chamado.origem.nomeResponsavel" disabled></InputText>
                </div>
                <div class="field col-12 md:col-4" v-if="chamado.statusChamado !== 'EM_ANALISE'">
                    <label for="emailResponsavel">Email do Responsável</label>
                    <InputText id="emailResponsavel" class="font-bold" :value="chamado.origem.emailResponsavel" disabled></InputText>
                </div>
                <div class="field col-12 md:col-2 sm:col-3">
                    <Button
                        label="Atribuir novo responsável"
                        icon="pi pi-sync"
                        class="mt-5 p-button"
                        @click="abrirDialog"
                        v-if="chamado.statusChamado !== 'EM_ANALISE'"
                    />
                </div>
            </div>
            <Dialog v-model="dialogVisible" :visible="dialogVisible" modal header="Atribuir chamado" :style="{ width: '25vw' }">
                <template #header>
                    <div class="inline-flex items-left gap-7">
                        <span class="font-bold whitespace-nowrap">Atribuir chamado</span>
                    </div>
                </template>
                <div class="field md:col-12">
                    <div class="formgrid grid p-fluid">
                        <label for="responsavel" class="required field col-12 md:col-12 pl-0">Responsável</label>
                        <Dropdown
                            v-model="responsavel"
                            :options="responsaveis"
                            filter
                            class="col-12 md:col-12 pl-0"
                            optionLabel="nome"
                            placeholder="Selecione"
                            :disabled="isDisabled"
                            id="nome"
                        />
                    </div>
                </div>
                <template #footer>
                    <Button label="Fechar" text severity="secondary" @click="dialogVisible = false" autofocus />
                    <Button label="Atribuir" outlined severity="secondary" :disabled="!responsavel" @click="this.confirmarAtribuirChamado()" autofocus />
                </template>
            </Dialog>
        </Fieldset>
        <Fieldset v-if="chamado.tipoChamado == 'CONSULTORIA_EXPREESS'">
            <template #legend>
                <div class="flex align-items-center text-primary">
                    <span class="pi pi-user"></span>
                </div>
            </template>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="nome">Nome</label>
                    <InputText id="nome" class="font-bold" :value="chamado.origem.consultoriaExpress.nome" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="cpf">CPF</label>
                    <InputText id="cpf" class="font-bold" :value="chamado.origem.consultoriaExpress.cpf" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="ni">CNPJ, DAP, NIRF, SICAB</label>
                    <InputText id="ni" class="font-bold" :value="chamado.origem.consultoriaExpress.ni" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="razaoSocial">Nome do Representante Legal</label>
                    <InputText id="razaoSocial" class="font-bold" :value="chamado.origem.consultoriaExpress.razaoSocial" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="cidade">Município</label>
                    <InputText id="cidade" class="font-bold" :value="chamado.origem.consultoriaExpress.cidade" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="cep">CEP (Solicitante)</label>
                    <InputText id="cep" class="font-bold" :value="chamado.origem.consultoriaExpress.cep" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="endereco">Endereço comercial</label>
                    <InputText id="endereco" class="font-bold" :value="chamado.origem.consultoriaExpress.endereco" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="endereco">Unidade Regional</label>
                    <InputText id="endereco" class="font-bold" :value="chamado.origem.consultoriaExpress.unidadeRegional" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="tema">Serviço Solicitado</label>
                    <InputText id="tema" class="font-bold" :value="chamado.origem.consultoriaExpress.tema" disabled />
                </div>
            </div>
        </Fieldset>
        <Fieldset v-if="chamado.tipoChamado == 'PRODUTO_REAL'">
            <template #legend>
                <div class="flex align-items-center text-primary">
                    <span class="pi pi-shopping-cart"> </span>
                </div>
            </template>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="email">E-mail (Gestor do projeto)</label>
                    <InputText id="email" type="email" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.emailGestor" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="gestor">Nome do Gestor do Projeto</label>
                    <InputText id="gestor" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.gestor" disabled></InputText>
                </div>
                <div class="field col-12 md:col-12">
                    <label for="evento">Nome do Evento</label>
                    <InputText id="nome" optionLabel="nome" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.eventoNome" disabled></InputText>
                </div>
                <div class="field col-12 md:col-3">
                    <label for="dataInicio">Data início do evento</label>
                    <InputText
                        id="dataInicio"
                        optionLabel="nome"
                        class="font-bold"
                        :value="chamado.origem.solicitacaoProdutoReal.dataInicio"
                        disabled
                    ></InputText>
                </div>
                <div class="field col-12 md:col-3">
                    <label for="dataFim">Data fim do evento</label>
                    <InputText id="dataFim" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.dataFim" disabled></InputText>
                </div>
                <div class="field col-12 md:col-3">
                    <label for="horario">Horário do evento</label>
                    <InputText id="horario" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.horario" disabled></InputText>
                </div>
                <div class="field col-12 md:col-3">
                    <label for="preco">Preço</label>
                    <InputText inputId="preco" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.preco" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="projeto">Projeto</label>
                    <InputText id="projeto" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.projeto" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="material">Material didático</label>
                    <InputText id="material" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.material" disabled></InputText>
                </div>
                <div class="field col-12 md:col-12">
                    <label for="unidade">Unidade do SEBRAE</label>
                    <InputText id="unidade" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.unidade" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="contrato">Contrato</label>
                    <InputText id="contrato" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.contrato" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="modalidade">Modalidade do Evento</label>
                    <InputText id="evento" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.modalidade" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="evento">Tipo do evento</label>
                    <InputText id="evento" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.evento" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="tema">Tema Principal</label>
                    <InputText id="tema" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.temas" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="complexidadeSelecionada">Complexidade da solução</label>
                    <InputText id="complexidadeSelecionada" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.complexidade" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="carga">Carga Horária</label>
                    <InputText id="carga" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.complexidade" disabled></InputText>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="geraCertificado">Irá gerar certificado</label>
                    <InputText id="geraCertificado" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.geraCertificado" disabled></InputText>
                </div>
                <div class="field col-12 md:col-12">
                    <label for="compexidade">Descrição</label>
                    <Textarea rows="5" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.descricao" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="compexidade">Descrição do Argumento de venda</label>
                    <Textarea rows="5" class="font-bold" :value="chamado.origem.solicitacaoProdutoReal.argumentoVenda" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <p for="anexos" v-if="chamado.origem.anexos && chamado.origem.anexos.length > 0">Arquivos anexado</p>
                    <template v-for="(item, index) in chamado.origem.anexos" v-bind:key="index">
                        <a @click.prevent="downloadArquivo(item.urlDownload, item.title)" style="cursor: pointer">
                            {{ item.title }}
                            <font-awesome-icon icon="download" size="lg" class="icon-button ml-2 p-text-primary" title="Download" />
                        </a>
                    </template>
                </div>
            </div>
        </Fieldset>
        <Fieldset v-if="chamado.tipoChamado == 'CURADORIA'">
            <template #legend>
                <div class="flex align-items-center text-primary">
                    <span class="pi pi-shopping-cart"> </span>
                </div>
            </template>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-12">
                    <label for="nomeGestor">Nome do Gestor</label>
                    <InputText id="nomeGestor" class="font-bold" :value="chamado.origem.curadoria.nomeGestor" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="unidade">Unidade</label>
                    <InputText id="unidade" class="font-bold" :value="chamado.origem.curadoria.unidade" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="necessidade">Necessidade</label>
                    <InputText id="necessidade" class="font-bold" :value="chamado.origem.curadoria.necessidade" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="temas">Temáticas</label>
                    <InputText id="temas" class="font-bold" :value="chamado.origem.curadoria.temas" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="publicoAlvo">Público Alvo</label>
                    <InputText id="publicoAlvo" class="font-bold" :value="chamado.origem.curadoria.publicoAlvo" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="instrumentoProduto">Instrumento do Produto</label>
                    <InputText id="instrumentoProduto" class="font-bold" :value="chamado.origem.curadoria.instrumentoProduto" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="tipoPagamento">Tipo de Pagamento</label>
                    <InputText id="tipoPagamento" class="font-bold" :value="chamado.origem.curadoria.tipoPagamento" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="prazo">Prazo</label>
                    <InputText id="prazo" class="font-bold" :value="chamado.origem.curadoria.prazo" disabled />
                </div>
                <div class="field col-12 md:col-6">
                    <label for="tipoProduto">Formato do Produto</label>
                    <InputText id="tipoProduto" class="font-bold" :value="chamado.origem.curadoria.tipoProduto" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="descricaoObjetivo">Objetivos e necessidades</label>
                    <Textarea rows="5" class="font-bold" :value="chamado.origem.curadoria.descricaoObjetivo" disabled />
                </div>
                <div class="field col-12 md:col-12" v-if="chamado.origem.curadoria.descricaoObjetivoKahoot">
                    <label for="descricaoObjetivoKahoot">Objetivo ação kahoot</label>
                    <Textarea rows="5" class="font-bold" :value="chamado.origem.curadoria.descricaoObjetivoKahoot" disabled />
                </div>
                <div class="field col-12 md:col-12">
                    <label for="informacaoAdicional">Informação adicional</label>
                    <Textarea rows="5" class="font-bold" :value="chamado.origem.curadoria.informacaoAdicional" disabled />
                </div>
            </div>
        </Fieldset>

        <Fieldset class="mt-5" v-if="chamado.tipoChamado != 'CONSULTORIA_EXPREESS'">
            <template #legend>
                <div class="flex align-items-center text-primary">
                    <span class="mr-2">Atendimento</span>
                    <span class="pi pi-check-square"> </span>
                </div>
            </template>

            <div v-for="resp in chamado.respostas" :key="resp.id" class="mb-5">
                <div class="flex justify-content-start flex-wrap mb-2">
                    <TagStatusChamado :status="resp.novoStatus" />
                </div>
                <div class="flex justify-content-start flex-wrap mb-3">
                    <div><span class="pi pi-user"> </span></div>
                    <div class="ml-2">{{ resp.createdBy }}</div>
                    <div class="ml-2">({{ $dateFormat(resp.created, 'DD/MM/YYYY HH:mm:ss') }})</div>
                </div>

                <p v-if="resp.resposta" class="font-italic">
                    {{ resp.resposta }}
                </p>
                <p v-if="resp.codSolucaoSas">
                    <span>Código Solução SAS: </span>
                    <span class="font-bold">{{ resp.codSolucaoSas }}</span>
                </p>

                <Divider></Divider>
            </div>

            <div class="p-fluid formgrid grid" v-if="chamado.statusChamado == 'EM_ANALISE'">
                <div class="field col-6 md:col-6">
                    <label for="novoStatus">Novo Status</label>
                    <Dropdown id="novoStatus" optionLabel="name" optionValue="value" v-model="resposta.novoStatus" filter :options="statusChamado"></Dropdown>
                </div>
                <div class="field col-6 md:col-6" v-if="resposta.novoStatus == 'PRODUTO_CADASTRADO' && chamado.tipoChamado == 'PRODUTO_REAL'">
                    <label for="codSolucaoSas">Código Solução SAS</label>
                    <InputText id="codSolucaoSas" v-model="resposta.codSolucaoSas"></InputText>
                </div>
                <div class="field col-12 md:col-12" v-if="resposta.novoStatus != 'PRODUTO_CADASTRADO'">
                    <label for="resposta">Resposta</label>
                    <Textarea rows="5" v-model="resposta.resposta" />
                </div>
            </div>
        </Fieldset>

        <template #footer>
            <Button label="Fechar" icon="pi pi-times" class="p-button-text" @click="fecharModal()" />
            <Button
                label="Nova Solução"
                icon="pi pi-pencil"
                @click="novaSolucao(chamado)"
                v-if="chamado.tipoChamado == 'PRODUTO_REAL' && chamado.statusChamado == 'EM_ANALISE'"
                style="background-color: #6c757d; border-color: #6c757d"
            />
            <Button
                label="Atender Chamado"
                icon="pi pi-check"
                class="p-button"
                @click="atenderChamado(chamado)"
                v-if="chamado.statusChamado == 'EM_ANALISE'"
                :disabled="!isRespostaValid"
            />
        </template>
    </Dialog>
</template>

<script>
import Services from './service';
import TagStatusChamado from './TagStatusChamado.vue';
import ServiceArquivo from '../shared/serviceArquivos';
import ServicesUsuario from '../controleacesso/services';

export default {
    name: 'DialogChamados',
    components: { TagStatusChamado },
    emits: ['close'],
    props: {
        chamado: {
            type: Object,
        },
        visible: {
            type: Boolean,
        },
    },
    data() {
        return {
            modal: false,
            resposta: {
                novoStatus: 'PRODUTO_CADASTRADO',
                resposta: '',
                codSolucaoSas: undefined,
            },
            statusChamado: [
                { name: 'Devolvido para ajustes', value: 'DEVOLVIDO_PARA_AJUSTES' },
                { name: 'Produto cadastrado', value: 'PRODUTO_CADASTRADO' },
                { name: 'Produto não cadastrado', value: 'PRODUTO_NAO_CADASTRADO' },
            ],
            responsavel: null,
            responsaveis: [],
            dialogVisible: false,
        };
    },
    computed: {
        isRespostaValid() {
            if (this.chamado.tipoChamado == 'CONSULTORIA_EXPREESS') {
                return !!this.resposta.novoStatus;
            } else if (this.chamado.tipoChamado == 'PRODUTO_REAL') {
                return (
                    (this.resposta.novoStatus == 'PRODUTO_CADASTRADO' && !!this.resposta.codSolucaoSas) ||
                    (this.resposta.novoStatus != 'PRODUTO_CADASTRADO' && !!this.resposta.resposta)
                );
            } else {
                return this.resposta.novoStatus == 'PRODUTO_CADASTRADO' || (this.resposta.novoStatus != 'PRODUTO_CADASTRADO' && !!this.resposta.resposta);
            }
        },
    },
    methods: {
        novaSolucao(chamado) {
            this.$router.push({ name: 'Solucao_Inserir', params: { chamado: JSON.stringify(chamado) } });
            this.fecharModal(false);
        },

        atenderChamado(chamado) {
            Services.responderChamado(chamado.id, this.resposta).then((response) => {
                if (response?.success) {
                    this.fecharModal(true);
                    this.$message({
                        severity: 'success',
                        summary: 'Sucesso',
                        detail: 'Chamado atendido com sucesso!',
                    });
                }
            });
        },
        obterTodosUsuariosSol() {
            ServicesUsuario.obterTodosUsuariosSol()
                .then((response) => {
                    if (response && response.data) {
                        this.responsaveis = response.data;
                    } else {
                        console.error('Não foi possível obter os usuários');
                    }
                })
                .catch((error) => {
                    console.error('Erro ao obter usuários:', error);
                });
        },
        confirmarAtribuirChamado() {
            this.$confirm.require({
                message: `Tem certeza que deseja atribuir para um novo responsável?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.atribuirNovoResponsavel();
                },
            });
        },

        atribuirNovoResponsavel() {
            this.$store.dispatch('addRequest');
            console.log(this.responsavel);
            const chamado = {
                chamadoId: this.chamado.id,
                nomeResponsavel: this.responsavel.nome,
                emailResponsavel: this.responsavel.email,
                usuarioIdResponsavel: this.responsavel.usuarioId,
                origemId: this.chamado.origemId,
            };
            Services.atribuirNovoResponsavelChamado(chamado).then((response) => {
                if (response && response.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Atribuir novo responsável',
                        detail: 'Novo responsável atribuido com sucesso',
                        life: 3000,
                    });
                    this.$store.dispatch('close', true);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Atribuir novo responsável',
                        detail: 'Erro ao atribuir novo responsável',
                        life: 3000,
                    });
                }
                this.dialogVisible = false;
                this.$store.dispatch('removeRequest');
            });
        },

        fecharModal(atualizar) {
            this.limparChamado();
            this.$emit('close', atualizar);
        },
        limparChamado() {
            this.resposta = {
                novoStatus: 'PRODUTO_CADASTRADO',
                resposta: '',
                codSolucaoSas: undefined,
            };
        },
        downloadArquivo(url, filename) {
            ServiceArquivo.downloadFileUrl(url).then((response) => {
                if (response?.success) {
                    this.$download(response.data, filename);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Anexo',
                        detail: 'Erro ao realizar download do Anexo',
                        life: 3000,
                    });
                }
            });
        },
        abrirDialog() {
            this.dialogVisible = true;
            this.obterTodosUsuariosSol();
        },
    },
    watch: {
        'resposta.novoStatus'() {
            if (this.resposta.novoStatus == 'PRODUTO_CADASTRADO') {
                this.resposta.resposta = undefined;
            } else {
                this.resposta.codSolucaoSas = undefined;
            }
        },
        visible() {
            this.modal = this.visible;
        },
        modal() {
            if (this.modal != this.visible) {
                this.$emit('close', false);
            }
        },
    },
};
</script>
